import { useAppSelector } from '@/redux/store';
import { UserFormSlice } from '@/redux/user-form';
import '@/components/upload-form/upload-form.css';

const UploadForm = () => {
  const lastName = useAppSelector(UserFormSlice.selectors.lastName);
  const email = useAppSelector(UserFormSlice.selectors.email);
  const iframeUrl = `https://forms.zohopublic.com/info114/form/Upload/formperma/M39ojQ7PFkoee35hKPIbFG22u1NyvUDHWV0VnlENNnY?nachname=${lastName}&email=${email}`;

  return (
    <div className={'slide-container upload-form-slide-container'}>
      <div
        style={{ display: 'none' }}
        className='upload-form-loader upload-form-circle-loader upload-form-load-complete'
      >
        <div className='upload-form-draw upload-form-show upload-form-checkmark' />
      </div>

      <div style={{ position: 'relative', textAlign: 'center', height: 200, display: 'block' }}>
        <div className='beforIframe upload-form-iframe-container'>
          <div className='leadfunnel-circle-loader circle-loader' />
          <div> Bitte Warten ...</div>
        </div>
      </div>
      <div style={{ display: 'block' }}>
        <iframe
          style={{
            width: '100%',
            height: '400px',
            textAlign: 'center',
          }}
          scrolling='no'
          frameBorder='0'
          className='upload-form-iframe'
          src={iframeUrl}
        />
      </div>
    </div>
  );
};

export default UploadForm;
